import type { Element, Root } from "hast";
import { createElement } from "react";
import type { Plugin } from "unified";
import { Test, visit } from "unist-util-visit";
import type { CitationComponent } from "../MarkdownWithCitations.tsx";
import { CITATION_NODE_TYPE } from "./constants.ts";
import { CitationNode } from "./remarkCitationPlugin.ts";

interface Options {
  CitationComponent: CitationComponent;
}

const check: Test = (node) => {
  return node.type === CITATION_NODE_TYPE;
};

const rehypeCitationPlugin: Plugin<[Options], Root> = ({
  CitationComponent: Component,
}) => {
  return (tree) => {
    visit(tree, check, (node) => {
      node.type = "element";
      const element: Element = node as unknown as Element;
      element.tagName = "span";
      element.properties = {};
      element.children = [
        {
          type: "raw",
          value: createElement(Component, {
            referenceIds: (node as unknown as CitationNode).referenceIds,
            data: (node as unknown as CitationNode).data,
          }) as unknown as string,
        },
      ];
    });
  };
};

export default rehypeCitationPlugin;
